import React from 'react';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';

function UndefinedAnonymousUser() {
  const spinnerId = 'header-user-area';
  const spinnerScale = 0.5;

  return (
    <li className="u-els-padding-left-1o2">
      <RxSpinnerComponent spinnerId={spinnerId} spinnerClass="eader-user-area" spinnerScale={spinnerScale} />
    </li>
  );
}

export default UndefinedAnonymousUser;
